const htmlToStringList = (html: string) => {
  const temp = document.createElement("div");
  temp.innerHTML = html;
  return Array.from(temp.children).map((child) => child.textContent);
}

const beforeUpdateFormatter = (fields: {
  source_id?: string | undefined;
  product_id: string;
  field_name: string;
  field_value: string;
}[]) => {
  return fields.map((field) => {
    if(field.field_name === "description_bullets"){
      return {
        ...field,
        field_value: JSON.stringify(htmlToStringList(field.field_value))
      }
    }else{
      return field;
    }
  })
}

export default beforeUpdateFormatter;